// Submits a server-built signed form to PayU hosted checkout (full-page redirect).
export function payWithPayU(payuUrl, params) {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = payuUrl;
  Object.entries(params).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value ?? "";
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
}
